<template>
<div>

  <bar-chart style="width: 100%; "
             :class="loading ? 'loading':''"
             :chartData="getChartData"
             :options="getOptions"/>
  </div>
</template>

<script>
import BarChart from '@/components/insights/charts/barChart.js'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";
import downTimesOee from "@/mixins/oeeAnalytics/downTimes"

const tinycolor = require('tinycolor2')
export default {
  components: {
    BarChart,
  },
  mixins: [timeCalc, generalMethods, chartColors, downTimesOee],
  props: ['hardwareLogs', 'bdr','selectedDate'],
  data() {
    return {
      loading: false,
      config: {}
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    ...mapGetters('workflows', ['getWorkflowName', 'getWorkflowColor', 'getWorkflows', 'getWorkflowIdByName']),
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getSelectedProductNumber', 'getUnit', 'getQueryFilters', 'getData']),
    getGroupBy() {
      // let lengthOfDateRange = moment(this.getQueryFilters.toDate).diff(this.getQueryFilters.fromDate, 'hours')
       if (this.selectedDate) {
        return 'minute'
      } else  {
        return 'day'
      }
    },
    getOptions() {
      const self = this
      return {
        ...this.generalChartOptions,
        scales: {
          offset: true, // IF this is set to false, it will not display the last bar!
          xAxes: [
            {
              gridLines: {
                display: false
              },
              offset: true, // IF this i
              stacked: false,
              type: 'time',
              // ticks: {
              //   min: self.config.typeOfPeriod == 'day' ? '00:00' : moment(this.config.startDate).startOf('isoWeek').toDate(),
              //   max: self.config.typeOfPeriod == 'day' ? '23:59' : moment(this.config.startDate).endOf('isoWeek').toDate(),
              // },
              time: {
                isoWeekday: true,
                unit: self.getGroupBy,

                // stepSize: 1,
                displayFormats: {
                  millisecond: 'DD HH:mm:ss', //I have tried without the 'a' too, same result
                  second: 'DD HH:mm:ss',
                  minute: 'DD-MM HH:mm',
                  hour: 'DD HH',
                  day: 'DD-MM',
                  week: 'DD-MM-YYYY',
                }
              }
            },
          ],
          yAxes: [{
            stacked: false,
            ticks: {
              maxTicksLimit: self.getGroupBy == 'day' ? 6 : 10,
              beginAtZero: true,
              autoSkip: true,
              stepSize: 2,
              callback: function (label, index, labels) {
                return label
              }
            }
          }],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          intersect: false,
          filter: function (tooltipItem) {
            let datasetIndex = tooltipItem.datasetIndex;
            if(self.getGroupBy == 'day'){
              return true
            }
            return !(datasetIndex == 1 || datasetIndex == 2 || datasetIndex == 4 || datasetIndex == 5);
          },
          // cornerRadius: 0,
          //
          // backgroundColor: 'black',
          // titleColor: 'white',
          // titleFont: {},
          // bodyColor: 'red',
          // caretSize: 20,
          // caretPadding: 5,
          // padding: 10,

          callbacks: {
            title: function (tooltip, el) {

              if (tooltip.length) {
                return moment(tooltip[0].label).format('DD-MM-YYYY HH:mm')
              }
            },
            label: function (tooltipItem) {
              let meta = self.getChartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return ' amount:  ' + tooltipItem.value + ' Productnumber: ' + (meta.productNumber ? meta.productNumber : '-')   //tooltipItem.value
            }
          }
        },
        hover: {
          animationDuration: 100,
          intersect: false,// duration of animations when hovering an item
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex > 0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0 ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
        onClick: function (evt, el) {
        //   console.log(this)
          try {
            // console.log(self.getChartData.datasets[el[0]._datasetIndex].data)
            // const idx = self._chart._data.getElementAtEvent(event)[0]._index;
            let date = self.getChartData.datasets[el[0]._datasetIndex].data[el[0]._index].t;

            self.$emit('dateSelected', moment(new Date(date)))
            // self.selectedDate = moment(new Date(datarecord.date))
            // if (!self.getSelectedDate) {
            //   self.$store.commit('oeeAnalytics/setSelectedDate', moment(new Date(datarecord.date), 'DD-MM-YYYY').toDate());
            // }
          } catch (e) {
            console.log(e)
          }
        }
      }
    },


    getChartData() {
      const self = this
      let logs = _.clone(_.orderBy(this.hardwareLogs, ['timestamp'], ['asc']))
      logs = logs.map((log, id) => {
        log.workflow = this.getWorkflowName(log.workflowId)
        return log
      });
      if (this.getSelectedProductNumber) {
        logs = _.filter(logs, log => {
          return log.productNumber === this.getSelectedProductNumber
        })
      }
      if (this.getWorkflowId) {
        logs = _.filter(logs, log => {
          return log.workflowId === this.getWorkflowId
        })
      }
      let logsByWorkflow = _.groupBy(logs, 'workflowId')
      let datasets = []
      _.each(logsByWorkflow, (logs, index) => {
        if (this.selectedDate) {
          logs = _.filter(logs, log => {
            return moment(log.timestamp).isSame(moment(this.selectedDate), 'day')
          })
        }
         let grouppedLogsByTimeStamp = _.groupBy(logs, (log) => {
          return moment(log.timestamp).startOf(this.getGroupBy).toDate()
        })

        let data = this.createDatasetData(grouppedLogsByTimeStamp, index)
        datasets.push({
          // barThickness: 5,
          label: this.getWorkflowName(index),
          backgroundColor: tinycolor(this.getWorkflowColor(index)).toRgbString(),
          data,
          stack: `stack 0 ${index}`,
        })
        if (this.getGroupBy == 'minute') {
          let bdrData = self.createBdrDataSet(data, index);
          const npcData = self.createNpcDataSet(data, index);
          datasets.push({
            // barThickness: 5,
            label: 'BDR ' + this.getWorkflowName(index),
            type: 'line',
            fill: false,
            tension: 0,
            order: 0,
            backgroundColor: '#565656',
            borderColor: '#565656',
            pointRadius: 0.1,
            pointBorderWidth: 0,
            pointBorderColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(0, 0, 0, 0)',
            data: bdrData,
            stack: `stack 1 ${index}`,
          });
          datasets.push({
            // barThickness: 5,
            label: 'NPC ' + this.getWorkflowName(index),
            type: 'line',
            fill: false,
            tension: 0,
            order: 0,
            borderDash: [5, 5],
            backgroundColor: '#929292',
            borderColor: '#929292',
            pointRadius: 0.1,
            pointBorderWidth: 0,
            pointBorderColor: 'rgba(0,0,0,0)',
            pointBackgroundColor: 'rgba(0, 0, 0, 0)',
            data: npcData,
            stack: `stack 1 ${index}`,
          })
        }
      })

      return {
        labels: [],
        datasets
      }
    },
  },
  methods: {
    createDatasetData(logs, index) {
      return _.chain(logs).map((log, id) => {
        return {
          date: id,
          productNumber: log[0].productNumber,
          t: id,
          y: _.sumBy(log, l => {
            return parseInt(l.amountProduced)
          })
        }
      }).value()
    },
    createBdrDataSet(data, workflowId) {
      let bdrDataArray = []
      _.each(data, log => {

        let bdr = _.find(this.getData('bdr'), bdrArray => {
          // console.log(log.productNumber,bdrArray.productNumber)
          return bdrArray.productNumber === log.productNumber && bdrArray.workflowId === workflowId;
        })
        if (bdr) {
          bdrDataArray.push({
            date: log.date,
            t: log.date,
            y: bdr.bdr && log.y > 0 ? bdr.bdr : 0
          })
        }
      })

      return bdrDataArray
    },
    createNpcDataSet(data, workflowId) {
      let npcData = []

      _.each(data, log => {

        let npc = _.find(this.getData('bdr'), bdrArray => {
           return bdrArray.productNumber === log.productNumber && bdrArray.workflowId === workflowId;
        })
          if (npc) {
          npcData.push({
            date: log.date,
            t: log.date,
            y: npc.npc && log.y > 0 ? (npc.npc * 1000 * 60) : 0
          })
        }
      })
      return npcData
    },
  },
  watch: {

  },
  created() {
  }
}
</script>

<style scoped lang="scss">
.chart-container {
  height: calc(100%)
}


.fa-chevron-square-left, .fa-chevron-square-right {
  font-size: 3rem;
  font-weight: 300;
  line-height: 1.5;
  cursor: pointer;
}

@media only screen and (max-width: 800px) {
  .chart-container {
    height: calc(100% - 10rem)
  }
}
</style>
